import { render, staticRenderFns } from "./VoucherTable.pug?vue&type=template&id=0708a3d0&scoped=true&lang=pug&"
import script from "./VoucherTable.vue?vue&type=script&lang=js&"
export * from "./VoucherTable.vue?vue&type=script&lang=js&"
import style0 from "./VoucherTable.scss?vue&type=style&index=0&id=0708a3d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0708a3d0",
  null
  
)

export default component.exports